<template lang="pug">
div
  router-link(:class="{ 'submitted': order.status === 'SUBMITTED' }" :to="'/user/orders/' + order.id") {{ order.request_name }}
    span
      | {{ order.status === 'SUBMITTED' ? ' (pending)' : '' }}
  .secondary
    | {{ order.vendor_name }}
    br
    span(v-show='showDate') {{ $formatDate(order.delivery_date) }}
    span(:class="{ 'hpad': showDate }") {{ $formatTime(order.delivery_time) }}
    span(:class="{ 'hpad': !showDate }")  Order \#{{ order.id }}
</template>

<script>
import moment from 'moment'

export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
    showDate: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data ( ) {
    return {
      moment,
    }
  }
}
</script>

<style scoped lang="sass">
  @import '../../variables'

  a
    font-weight: 600
  .secondary
    margin: 0.2rem 0 0.5rem
    font-size: 0.8em
    color: #666

  .submitted
    color: #666
    font-style: italic

</style>


// WEBPACK FOOTER //
// src/user/blocks/OrderMini.vue